import React, { Component } from 'react'
import withRouter from '../lib/withRouter';
import { connect } from 'react-redux';
import Authentication from '../../session';
import Service from '../services'
import { BasicLazyParams } from '../../utile';
import { getBranchesLatest } from '../../store/actions';
import { Button } from 'primereact/button';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import ClassetCalendar from '../../classetComponents/classetCalender';
import BranchToSectionMultiDDTillSecReports from '../BaseDropdownComponents/BranchToSectionMultiDDTillSecReports';
import LoadingComponent from '../loadingComponent';
import { Toast } from 'primereact/toast';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import moment from 'moment';
import { baseUrlAdmin } from '../../store/apiConstants';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const dateRangeOptions = [
    { value: 1, label: "Today" },
    { value: 2, label: "This Week" },
    { value: 3, label: "This Month" },
    { value: 4, label: "Academic Session" },
    // { value: 5, label: "Custom" },
]

class FeeConcessionReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dropdownsData: {},
            lazyParams: BasicLazyParams,
            feeConcessionReport: [],
            filteredData: [],
            currentData: [],
        }
        this.service = new Service()
    }

    componentDidMount() {
        // this.props.getBranchesLatest(true)
        this.getFeeConcessionReportInfo()
    }

    setDropdownValues = (dropdownsData) => {
        this.setState(
            { dropdownsData, lazyParams: { ...this.state.lazyParams, first: 0, page: 0 } },
            () => {
                if (this.state.dropdownsData?.sectionIds) {
                    this.getFeeConcessionReportInfo();
                }
            }
        );
    }

    getFeeConcessionReportInfo = async () => {
        let { lazyParams, globalSearch } = this.state;
        this.setState({
            isLoading: true,
        });
        let url = `${baseUrlAdmin}/financeReports/feeConcessionReport?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}`;
        let payload = {
            academicYear: localStorage.getItem('userAcademicYear'),
            boardIds: this.state.dropdownsData.boardIds,
            classIds: this.state.dropdownsData.classIds,
            branchIds: this.state.dropdownsData.branchIds,
            sectionIds: this.state.dropdownsData.sectionIds,
            dateRangeType: this.state.dateRangeType,
        }
        this.service.post(url, payload, true).then(data => {
            if (data.status && data?.res?.status) {
                this.setState({
                    feeConcessionReport: data?.res?.data,
                    filteredData: data?.res?.data,
                    totalRecords: data?.res?.totalRecords,
                    isLoading: false
                });
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    applyAllFilters = () => {
        const { feeConcessionReport, dropdownsData, dateRangeType, lazyParams } = this.state;
        let filtered = [...feeConcessionReport];

        // Apply dropdown filters
        if (dropdownsData.sectionIds?.length) {
            filtered = filtered.filter(item =>
                dropdownsData.sectionIds.includes(item.sectionId)
            );
        }

        // Apply date range filter
        if (dateRangeType) {
            filtered = this.filterByDateRange(filtered, dateRangeType);
        }

        // Apply pagination
        const first = lazyParams.first || 0;
        const rows = lazyParams.rows || 10;
        const paginatedData = filtered.slice(first, first + rows);

        this.setState({
            filteredData: paginatedData,
            totalRecords: filtered.length
        });
    }

    filterByDateRange = (data, dateRangeType) => {
        const today = moment();

        switch (dateRangeType) {
            case 1: // Today
                return data.filter(item =>
                    moment(item.concessionDate).isSame(today, 'day')
                );
            case 2: // This Week
                return data.filter(item =>
                    moment(item.concessionDate).isSame(today, 'week')
                );
            case 3: // This Month
                return data.filter(item =>
                    moment(item.concessionDate).isSame(today, 'month')
                );
            case 4: // Academic Session
                return data;
            default:
                return data;
        }
    }

    onPage = (event) => {
        this.setState((prevState) => ({
            lazyParams: { ...prevState.lazyParams, ...event }
        }), () => {
            this.getFeeConcessionReportInfo();
        });
    };

    exportToExcel = async () => {
        this.setState({ isLoading: true });
        const payload = {
            academicYear: localStorage.getItem('userAcademicYear'),
            boardIds: this.state.dropdownsData.boardIds,
            classIds: this.state.dropdownsData.classIds,
            branchIds: this.state.dropdownsData.branchIds,
            sectionIds: this.state.dropdownsData.sectionIds,
            dateRangeType: this.state.dateRangeType,
            download: true,
        };
        const response = await this.service.post(`${baseUrlAdmin}/financeReports/feeConcessionReport?search=`, payload, true);
        this.setState({ isLoading: false });
        const allData = response?.res?.data || [];
        if (!allData.length) {
            this.toast.show({ severity: 'warn', summary: 'No Data', detail: 'No records to export', life: 3000 });
            return;
        }

        // Transform data for excel
        const excelData = allData.map(item => ({
            'Student Id': item.enrollmentId,
            'Student Name': item.studentName,
            'Branch': item.branchName,
            'Board': item.boardName,
            'Class-Section': `${item.className}-${item.sectionName}`,
            "Fee Type": item.feeType,
            'Concession Date': item.concessionDate ? moment(item.concessionDate).format('DD/MM/YYYY') : '-',
            'Concession Amount': item.concessionAmount,
            'Reason': item.concessionType
        }));

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Fee Concession Report');

        // Save file
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const fileBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(fileBlob, `Fee_Concession_Report_${moment().format('DD-MM-YYYY')}.xlsx`);
    };

    render() {
        return (
            <>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    padding: '0',
                    marginLeft: "100px",
                    marginTop: "55px",
                    overflow: 'auto',

                }}>
                    <div className="card filters-card mt-1 pt-0">
                        <BranchToSectionMultiDDTillSecReports setValues={this.setDropdownValues} />
                        <div className="grid m-2 ml-0">
                            <div className="col-3">
                                <label className="add-vehicle-field-label">Date Range</label>
                                <ClassetDropdown
                                    options={dateRangeOptions}
                                    value={this.state.dateRangeType}
                                    onChange={(e) => {
                                        this.setState(
                                            { dateRangeType: e.target.value, lazyParams: { ...this.state.lazyParams, first: 0, page: 0 } },
                                            () => { this.getFeeConcessionReportInfo(); }
                                        );
                                    }}
                                    style={{ border: '10px solid #E6E8EA', }}
                                    placeholder={(
                                        <div className="flex justify-content-start  align-items-center">
                                            <span className=''>Select Range</span>
                                        </div>
                                    )}
                                />


                            </div>
                            {this.state.dateRangeType == 5 &&
                                <>
                                    <div className="col-3">
                                        <label className='label'>From Date</label>
                                        <ClassetCalendar
                                            calendarMode="single"
                                            className="text-xl"
                                            value={this.state.chequeFromDate}
                                            placeholder="Select From Date"
                                            onChange={(e) => {
                                                this.setState({ chequeFromDate: e.value }, () => {
                                                    this.state.chequeFromDate !== "" && this.state.chequeToDate !== "" && this.getChequeInfo();
                                                })
                                            }}
                                        />

                                    </div>
                                    <div className="col-3">
                                        <label className='label'>To Date</label>
                                        <ClassetCalendar
                                            calendarMode="single"
                                            className="text-xl"
                                            value={this.state.chequeToDate}
                                            placeholder="Select To Date"
                                            onChange={(e) => {
                                                this.setState({ chequeToDate: e.value }, () => {
                                                    this.state.chequeFromDate !== "" && this.state.chequeToDate !== "" && this.getChequeInfo();
                                                })
                                            }}
                                        />
                                    </div>
                                </>
                            }
                            <div className="col-3 mt-5 flex justify-content-end align-items-center gap-5 ms-auto" style={{ maxWidth: 'fit-content' }}>
                                <Button
                                    label="Download Report"
                                    onClick={this.exportToExcel}
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#F4F5F6", color: "#000" }}
                                />
                                <Button label="View Analysis" className="p-button-primary"
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#076EFF", color: "#fff", }} />
                            </div>

                        </div>
                    </div>


                    <div className='datatable-report-demo mx-2'>
                        <DataTable
                            value={this.state.filteredData}
                            dataKey="id"
                            paginator
                            lazy
                            responsiveLayout="scroll"
                            columnResizeMode="expand"
                            resizableColumns
                            onPage={this.onPage}
                            first={this.state.lazyParams.first}
                            rows={this.state.lazyParams.rows}
                            totalRecords={this.state.totalRecords}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            globalFilter={this.state.globalFilter}
                        >
                            <Column field="" header="Student Id"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData.enrollmentId || rowData?.username}
                                        </p>
                                    )
                                }}
                            />

                            <Column filterField="firstName" field="" header="Student Name"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData.studentName}
                                        </p>
                                    )
                                }}
                            />

                            <Column filterField="branchName" field="username" header="Branch"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.branchName}
                                        </p>
                                    )
                                }} />
                            <Column filterField="boardName" header="Board"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.boardName}
                                        </p>
                                    )
                                }} />
                            <Column filterField="className" field="username" header="Class-Section"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.className + "-" + rowData?.sectionName}
                                        </p>
                                    )
                                }} />
                            <Column



                                header="Concession Date"

                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.concessionDate ? moment(rowData.concessionDate).format('DD/MM/YYYY') : '-'}
                                        </p>
                                    )
                                }}
                            />
                            <Column field="username" header="Fee Type"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.feeType}
                                        </p>
                                    )
                                }}
                            />
                            <Column field="username" header="Concession Amount"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <p>
                                            {rowData?.concessionAmount.toFixed(2)}
                                        </p>
                                    )
                                }}
                            />

                            <Column filterField="receiptNo" field="concessionType" header="Reason" />


                        </DataTable>
                    </div>
                </div>
                {this.state.isLoading && <LoadingComponent />}
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </>
        )
    }
}


const mapStateToProps = (state) => ({
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._idF
});
export default connect(mapStateToProps, {
    getBranchesLatest
})(Authentication(withRouter(FeeConcessionReport)));